import React from 'react';
// Styles
import { UseStyles } from './healthMetricStyles';
import './dashboardStyles.css';
// Material UI
import MaterialTable from 'material-table';

import { differenceInDays } from 'date-fns'

const columns = [
  { title: "ID", field: "id", minWidth: 90, defaultSort: 'desc' },
  {
    title: "Name",
    field: "name",
    minWidth: 250,
    render: rowData => {
      return (
        <a href={`/#/Project/${rowData.id}/show`}
           style={{
             width: 50,
             borderRadius: '8px',
             textDecoration: 'none',
             color: 'inherit',
           }}>{rowData.name}</a>);
    }
  },
  { title: "Classification", field: "classification", minWidth: 145 },
  { title: "Start", field: "start_date", minWidth: 110 },
  { title: "End", field: "end_date", minWidth: 115 },
  {
    title: "logged in last month",
    field: "userLoggedInLastMonth",
    minWidth: 150,
    defaultSort: 'desc',
    customSort: (a, b) => a.userLoggedInLastMonth.length - b.userLoggedInLastMonth.length || a.name.localeCompare(b.name),
    render: rowData => {
      if (Array.isArray(rowData.userLoggedInLastMonth)) {
        return (
          <a
            href={`/#/User?displayedFilters={}&filter={"ids"%3A[${rowData.userLoggedInLastMonth.map(u => u.id).join(', ')}]}&order=ASC&page=1&perPage=100&sort=id`}
            style={{
              width: 50,
              borderRadius: '8px',
              textDecoration: 'none',
              color: 'inherit',
            }}>{rowData.userLoggedInLastMonth.length}</a>);
      }
      return rowData.userLoggedInLastMonth;
    }
  },
  {
    title: "logged in last week",
    field: "userLoggedInLastWeek",
    minWidth: 150,
    customSort: (a, b) => a.userLoggedInLastWeek.length - b.userLoggedInLastWeek.length || a.name.localeCompare(b.name),
    render: rowData => {
      if (Array.isArray(rowData.userLoggedInLastWeek)) {
        return (
          <a
            href={`/#/User?displayedFilters={}&filter={"ids"%3A[${rowData.userLoggedInLastWeek.map(u => u.id).join(', ')}]}&order=ASC&page=1&perPage=100&sort=id`}
            style={{
              width: 50, borderRadius: '8px', textDecoration: 'none', color: 'inherit'
            }}>{rowData.userLoggedInLastWeek.length}</a>);
      }
      return rowData.userLoggedInLastWeek;
    }
  },
  {
    title: "# admins", field: "numberOfAdmins", minWidth: 115,
    customSort: (a, b) => a.numberOfAdmins.length - b.numberOfAdmins.length || a.name.localeCompare(b.name),
    render: rowData => {
      if (Array.isArray(rowData.numberOfAdmins)) {
        return (
          <a
            href={`/#/User?displayedFilters={}&filter={"ids"%3A[${rowData.numberOfAdmins.map(u => u.id).join(', ')}]}&order=ASC&page=1&perPage=100&sort=id`}
            style={{
              width: 50, borderRadius: '8px', textDecoration: 'none', color: 'inherit'
            }}>{rowData.numberOfAdmins.length}</a>);
      }
      return rowData.numberOfAdmins;
    }
  },
  {
    title: "# End users", field: "numberOfEndUsers", minWidth: 155,
    customSort: (a, b) => a.userLoggedInLastWeek.length - b.userLoggedInLastWeek.length || a.name.localeCompare(b.name),
    render: rowData => {
      if (Array.isArray(rowData.numberOfEndUsers)) {
        return (
          <a
            href={`/#/User?displayedFilters={}&filter={"ids"%3A[${rowData.numberOfEndUsers.map(u => u.id).join(', ')}]}&order=ASC&page=1&perPage=100&sort=id`}
            style={{
              width: 50, borderRadius: '8px', textDecoration: 'none', color: 'inherit'
            }}>{rowData.numberOfEndUsers.length}</a>);
      }
      return rowData.numberOfEndUsers;
    }
  },
  { title: "# companies on Project", field: "numberOfCompaniesOnProject", minWidth: 175 },
  { title: "weekly reports enabled by admin", field: "adminWeeklyReport", minWidth: 200 },
  { title: "Admin has in-app notifications", field: "adminHasInAppNotifications" },
  { title: "Number of ITP Reports", field: "numberOfITPReportAdminCreated" },
  { title: "Number of Progress claims", field: "numberOfProgressClaimReportAdminCreated" },
  { title: "Number of Packing List", field: "numberOfPackingListReportAdminCreated" },
  { title: "Number of Defect reports", field: "numberOfDefectReportAdminCreated" },
  { title: "Custom reports are setup", field: "adminHasCustomReportsSetup" },
];

columns.forEach(column => column.cellStyle = { textAlign: 'center' });

export const ProjectHealthDatagrid = props => {
  const classes = UseStyles();

  const companyProjectData = [];

  props.projectInfo.forEach(p => {
    const companiesOnProject = props.companyInfo.filter(c => c.projects.find(cp => cp.id === p.id));
    p.userLoggedInLastWeek = [];
    p.userLoggedInLastMonth = [];
    companiesOnProject.forEach(c => {
      const withStats = {
        ...c,
        id: `${p.id}-${c.id}`,
        classification: c.company_trade,
        parentId: p.id,
        numberOfAdmins: c.users.filter(u => u.projectAccess.find(pA => pA.project.id === p.id && pA.level === 3)),
        numberOfEndUsers: c.users.filter(u => u.projectAccess.find(pA => pA.project.id === p.id && (pA.level === 2 || pA.level === 1))),
        userLoggedInLastWeek: c.users.filter(u => u.projectAccess.find(pA => pA.project.id === p.id && pA.last_accessed_date !== null && differenceInDays(new Date(), new Date(pA.last_accessed_date)) < 8)),
        userLoggedInLastMonth: c.users.filter(u => u.projectAccess.find(pA => pA.project.id === p.id && pA.last_accessed_date !== null && differenceInDays(new Date(), new Date(pA.last_accessed_date)) < 31)),
      }
      p.userLoggedInLastWeek = p.userLoggedInLastWeek.concat(...withStats.userLoggedInLastWeek)
      p.userLoggedInLastMonth = p.userLoggedInLastMonth.concat(...withStats.userLoggedInLastMonth)

      companyProjectData.push(withStats)
    })
    console.log('p', p)
  })

  return (
    <MaterialTable
      className={classes.root}
      title='Project Health Dashboard'
      data={[...props.projectInfo, ...companyProjectData]}
      columns={columns}
      parentChildData={(row, rows) => {
        return props.projectInfo.find(a => a.id === row.parentId)
      }}
      options={{
        maxBodyHeight: '90vh',
        defaultExpanded: false,
        selection: false,
        searchFieldAlignment: 'left',
        paging: true,
        pageSize: 10, // set initial page size
        emptyRowsWhenPaging: false, // To avoid having empty rows
        pageSizeOptions: [5, 10, 20, 50, 100, 200, 500, 1000],
        showTitle: false,
        exportButton: true,
        filtering: true,
        rowStyle: rowData => ({
          backgroundColor: !!rowData.parentId ? "#e8f0f5" : "#FFF",
          fontWeight: !!rowData.parentId ? '500' : 'normal',
          textAlign: 'center'
        }),
      }}
    />
  );
}
